<template>
  <section class="container">
    <Loading v-show="loading"></Loading>
    <h3>{{ info.title }}</h3>
    <div class="rich" v-html="info.content"></div>
    <div class="buttom">
      <router-link v-if="pageother?.prveinfo?.id" class="prev iconfont icon-jiantou-copy"
        :to="{ path: '/case/info', query: { id: pageother?.prveinfo?.id } }">
        <span class="dh_text">perv：{{ pageother?.prveinfo?.title }}</span>
      </router-link>
      <a v-else class="prev iconfont icon-jiantou-copy" href="JavaScript:;">perv：none</a>
      <router-link :to="{ path: '/case' }">back</router-link>
      <router-link v-if="pageother?.nextinfo?.id" class="next iconfont icon-jiantou"
        :to="{ path: '/case/info', query: { id: pageother?.nextinfo?.id } }">
        <span class="dh_text">next：{{ pageother?.nextinfo?.title }}</span>
      </router-link>
      <a v-else class="next iconfont icon-jiantou" href="JavaScript:;">next：none</a>
    </div>
  </section>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      loading: false,
      pageother: {},
      info: {},
      id: this.$route.query.id,
    };
  },
  created() {
    this.casesInfo();
  },
  methods: {
    async casesInfo() {
      this.loading = true;
      let res = await service.casesInfo({ id: this.id });
      this.loading = false;
      this.info = res.data.caseinfo;

      let ss = `src="${this.$baseURL}`;
      this.info.content = this.info.content.split(`src="`).join(ss);
      this.pageother = res.data.pageother;
    },
  },
  watch: {
    $route(to, from) {
      this.id = to.query.id;
      this.casesInfo();
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
}

h3 {
  margin-bottom: 20px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 20px;
  font-size: 20px;
}

.buttom {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  border-top: 1px solid #ddd;
  padding-top: 20px;
  font-size: 14px;
  color: #666;

  a {
    max-width: 25%;
    color: var(--themeColor);
    font-size: 16px;
  }

  .prev,
  .next {
    display: flex;
    font-family: Regular !important;
    color: #666;

    &::before {
      font-family: iconfont !important;
      color: var(--themeColor2);
      margin-right: 10px;
    }
  }

  .next {
    display: flex;
    flex-direction: row-reverse;

    &::before {
      margin-left: 10px;
      margin-right: 0;
    }
  }
}
</style>